module.exports = __WEBPACK_EXTERNAL_MODULE__ux_button__;